export const appsAppGroupIdChartsEmail = "/apps/:app_group_id/charts/email";
